// @flow
import * as React from 'react';
import zIndices from 'app/common/react/components/DeprecatedPinRep/styles/zIndices';
import { Box, Text } from 'gestalt';

type Props = {
  children: ?any,
  debugImpressionLogged?: boolean,
  debugImpressionStarted?: boolean,
  slotIndex: number,
};

export default function DebugPinImpressions(props: Props) {
  const { debugImpressionStarted, debugImpressionLogged, slotIndex } = props;
  const debugStyle =
    debugImpressionLogged || debugImpressionStarted
      ? {
          ...(debugImpressionLogged && !debugImpressionStarted ? { opacity: 0.1 } : {}),
          ...(debugImpressionStarted ? { backgroundColor: '#adebad' } : {}),
          height: '100%',
          width: '100%',
        }
      : null;
  return (
    <div style={debugStyle}>
      {(debugImpressionStarted || debugImpressionLogged) && (
        <Box
          position="absolute"
          padding={2}
          color="darkGray"
          dangerouslySetInlineStyle={{ __style: { zIndex: zIndices.debugPinImpressions } }}
        >
          <Text size="xl" color="white">
            {slotIndex}
          </Text>
        </Box>
      )}
      {props.children}
    </div>
  );
}
